import React, {Component} from "react";
import {connect} from "react-redux";
import PanelGroupController from "../../components/PanelGroupController";
import {cx} from "../../lib/ClassSet";
import {graphql} from "react-apollo";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {ORDER_LOG, ON_ORDER_LOG_UPDATED} from "../../queries/shipping";
import {fromJS} from "immutable";
import update from "immutability-helper";
import {dateWithTimeFormat} from "../../lib/DateFormatter";
import "./LogPanel.scss";

class LogPanel extends Component {

  componentDidMount() {
    if (this.props.orderId) {
      this.subscribe(this.props);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.orderId && (prevProps.orderId !== this.props.orderId)) {
      this.subscribe(this.props);
    }
  }

  subscribe(props) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToMore(props, {});
  }  


  render() {
    let {loading, error, shippingOrderLog} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let items = fromJS(shippingOrderLog);

    let elements = items.map(x => {
      return <LogItem key={x.get("eventId")} data={x} />
    })

    let classes = cx({
      "LogPanel": true,
      "u-limitHeight": this.props.limitHeight
    })

    return (
      <div className={classes}>
        <PanelGroupController title="Event Log" expanded={true}>
          {elements}
        </PanelGroupController>
      </div>
    )
  }

}

const withQuery = graphql(ORDER_LOG, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      orderId: props.orderId
    }
  })
})

const mapDispatchToProps = dispatch => ({
  subscribeToMore: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_ORDER_LOG_UPDATED,
      variables: {
        orderId: props.orderId
      },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          shippingOrderLog: {
            $unshift: [subscriptionData.data.updatedShippingOrderLog]
          }
        })
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

LogPanel.defaultProps = {
  limitHeight: true
}

export default withQuery(withSubscription(LogPanel));



const LogItem = (props) => {

  let data = props.data;
  let code = data.get("isError") ? "Err" : "Ok";

  let classes = cx({
    "item": true,
    "u-error": data.get("isError")
  })

  var rxp = /\[([a-z_]+):([0-9a-z \-_]+)\]/gi;
  let markup = {__html: data.get("description").replace(rxp, '<span>$2</span>')};

  return (
    <div className={classes}>
      <div className="header">
        <div className="result">{code}</div>
        <div>
          <div className="description" dangerouslySetInnerHTML={markup}/>
          <span className="occuredAt">{dateWithTimeFormat(data.get("occuredAt"))}</span>
        </div>
      </div>
    </div>
  )

}